// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"204":"c06b154c","918":"8600f90c"}[chunkId] + ".css";
};